
import {mousePos, winsize} from './bundle'

class HoverReveal{
    constructor(item){
		this.item = item
        this.reveal = this.item.querySelector('.hover-reveal')
        this.revealInner = this.item.querySelector('.hover-reveal__inner')
        this.revealImg = this.item.querySelector('.hover-reveal__img')

        this.revealHeight = this.reveal.getBoundingClientRect().height
        this.initEvents()
    }


    initEvents(){
        // console.
        this.item.addEventListener('mousemove', () => {
            if(this.item.classList.contains('current')) return
            this.positionElement()
        })

        this.item.addEventListener('mouseenter', ev => {
            if(this.item.classList.contains('current')) return
            this.positionElement()
            this.showImage()

        })
        this.item.addEventListener('mouseleave', () => {
            this.hideImage()
        });




        this.positionElement = () => {
            // const docScrolls = {
            //     left : document.body.scrollLeft + document.documentElement.scrollLeft,
            //     top : document.body.scrollTop + document.documentElement.scrollTop
            // }
            // const k = 1 - (2*(winsize.height - this.item.getBoundingClientRect().y) / winsize.height) // [-1,1]
            // console.log(mousePos.y-this.item.getBoundingClientRect().y)
            // console.log(mousePos.y-this.item.getBoundingClientRect().y+((k-1)*this.revealHeight))
            this.revealHeight = this.reveal.getBoundingClientRect().height
            const k = (winsize.height - this.item.getBoundingClientRect().y) / winsize.height
            if(this.item.querySelector('.hover-reveal') !== null){
	            this.reveal.style.top = `${mousePos.y-this.item.getBoundingClientRect().y+((k-1)*this.revealHeight)}px`;
	            // this.reveal.style.top = `${mousePos.y-this.item.getBoundingClientRect().y}px`;
	            this.reveal.style.left = `${(mousePos.x*0.1)}px`;
        	}
        }

    }


    hideImage() {
        TweenMax.killTweensOf(this.revealInner);
        TweenMax.killTweensOf(this.revealImg);

        this.tl = new TimelineMax({
            onStart: () => {
                TweenMax.set(this.item, {zIndex: 601});
            },
            onComplete: () => {
                TweenMax.set(this.item, {zIndex: ''});
                TweenMax.set(this.reveal, {opacity: 0});
            }
        })
        .add('begin')
        .add(new TweenMax(this.revealInner, 0.6, {
            ease: Expo.easeOut,
            y: '-120%',
            rotation: -5
        }), 'begin')
        .add(new TweenMax(this.revealImg, 0.6, {
            ease: Expo.easeOut,
            y: '120%',
            rotation: 5,
            scale: 1.2
        }), 'begin')
    }
    showImage() {
        TweenMax.killTweensOf(this.revealInner);
        TweenMax.killTweensOf(this.revealImg);

        this.tl = new TimelineMax({
            onStart: () => {
                this.reveal.style.opacity = 1;
                TweenMax.set(this.item, {zIndex: 602});
            }
        })
        .add('begin')
        .set([this.revealInner, this.revealImg], {transformOrigin: '50% 100%'})
        .add(new TweenMax(this.revealInner, 0.6, {
            ease: Expo.easeOut,
            startAt: {x: '50%', y: '120%', rotation: 50},
            x: '0%',
            y: '0%',
            rotation: 0
        }), 'begin')
        .add(new TweenMax(this.revealImg, 0.6, {
            ease: Expo.easeOut,
            startAt: {x: '-50%', y: '-120%', rotation: 0},
            x: '0%',
            y: '0%',
            rotation: 0
        }), 'begin')
        .add(new TweenMax(this.revealImg, 0.6, {
            ease: Expo.easeOut,
            startAt: {scale: 2},
            scale: 1
        }), 'begin');
    }
}

export {HoverReveal}
